import { render, staticRenderFns } from "./IpFirewall.vue?vue&type=template&id=1615d509&scoped=true"
import script from "./IpFirewall.vue?vue&type=script&lang=js"
export * from "./IpFirewall.vue?vue&type=script&lang=js"
import style0 from "./IpFirewall.vue?vue&type=style&index=0&id=1615d509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1615d509",
  null
  
)

export default component.exports